module.exports = __webpack_public_path__ + "static/media/lowcode_logo_signin.c2d2744e.svg";